module.exports = __webpack_public_path__ + "static/img/promotion-banner-mob.d1adb4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/promotion-banner-mob.jpg
// module id = 0kkM
// module chunks = 2